import { Moment } from "moment";
import {
  InvoiceStatus,
  InvoicePaymentDisplayStatus,
  Role,
  PaymentStatus,
} from "../enums";
import { ExtendedInvoiceStatus } from "../types";
import { hasDatePassed } from "./dateUtil";

export const getInvoiceStatus = (
  status: InvoiceStatus,
  dueDate: string | Moment,
  role: Role,
  isTransactionInitiated = false,
): ExtendedInvoiceStatus => {
  if (isTransactionInitiated) {
    return InvoicePaymentDisplayStatus.TransactionInitiated;
  }

  if (
    [
      InvoiceStatus.InProgress,
      InvoiceStatus.SendToCustomer,
      InvoiceStatus.SendToQuickbooks,
    ].includes(status)
  ) {
    return hasDatePassed(dueDate)
      ? InvoicePaymentDisplayStatus.Overdue
      : InvoicePaymentDisplayStatus.WithinDue;
  }

  if (status === InvoiceStatus.PaymentReceived && role === Role.Customer) {
    return InvoicePaymentDisplayStatus.Paid;
  }

  return status;
};

export const getPaymentStatus = (status: PaymentStatus): string => {
  switch (status) {
    case PaymentStatus.PaymentSuccess:
      return "Payment Received";
    case PaymentStatus.ReturnSuccess:
      return "Refund Completed";
    case PaymentStatus.ReturnFailed:
      return "Refund Failed";
    default:
      return status
        .split("-")
        .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
        .join(" ");
  }
};
